import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { UseCases } from "@/components/landing/UseCases";
import { Features } from "@/components/landing/Features";
import { Pricing } from "@/components/landing/Pricing";
import { Faq } from "@/components/landing/Faq";
import { FinalCta, Footer } from "@/components/landing/FinalCta";

export default function Landing() {
  return (
    <main data-testid="landing-page">
      <Navbar />
      <Hero />
      <HowItWorks />
      <UseCases />
      <Features />
      <Pricing />
      <Faq />
      <FinalCta />
      <Footer />
    </main>
  );
}
